import axios from 'axios'

const globalApi = axios.create({
  baseURL: process.env.REACT_APP_API,
})

export default globalApi
